import * as React from 'react';
import { createRoot } from 'react-dom/client';

import TextField from '@mui/material/TextField';

import Autocomplete from '@mui/material/Autocomplete';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import Chip from '@mui/material/Chip';
import DoneIcon from '@mui/icons-material/Done';

import { styled, useTheme } from '@mui/material/styles';

export default function editorMultiple(cell, onRendered, success, cancel, editorParams){
  const editor = document.createElement("div");
  editor.style.width = "100%";
  editor.style.height = "100%";
  const styleBorder = cell.getElement().style.border
  cell.getElement().style.border = 'none';
  
  const value = cell.getValue();
  let valueArray = [];
  if (Array.isArray(value)) valueArray = value;
  else valueArray = value.split(',');
  valueArray = valueArray.filter(value => Boolean(value));

  const root = createRoot(editor);

  const bs4Success = (value) => {
    cell.getElement().style.border = styleBorder;
    root.unmount()
    success(value);
  }

  onRendered(() => {
    root.render(
      <ViewComponentSelect
        value={valueArray} 
        options={editorParams.values} 
        multiple={editorParams.multiselect} 
        editorParams={editorParams}
        bs4Success={bs4Success}
        cancel={cancel}
        cell={cell}
        editor={editor}
      />);      
  });
  
  return editor;
}

const ViewComponentSelect = (props) => {
  const [value, setValue] = React.useState(() => {
    const valueSet = new Set(props.value);
    return props.options.filter(option => valueSet.has(option.id));
  });
  const refResize = React.useRef()
  const awayRef = React.useRef({mouseTextField: true,});      
  const theme = useTheme();

  const onClose = (event, reason) => {
    event.stopPropagation();
    if (reason === 'toggleInput') {
      props.bs4Success(value.map(option => option.id));
    }
  }

  const onchange = (event, newValue) => {
    setValue(newValue)
  }

  const onBlurTextField = (e) => {
    if (awayRef.current.mouseTextField) {
       props.bs4Success(value.map(option => option.id));
    }
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    e.stopPropagation();
  }

  const onKeyDownTextField = (e) => {
    switch(e.keyCode){
      case 13: //Enter
        props.bs4Success(value.map(option => option.id));
        break;

      case 9: //Tab
        awayRef.current.mouseTextField = true
        break;

      case 27:  //Esc
        props.cancel();
        break;

      case 38: //up arrow
      case 40: //down arrow
        if (props?.editorParams?.verticalNavigation == "editor"){
          if (e.stopImmediatePropagation) e.stopImmediatePropagation();
          e.stopPropagation();
        } else {          
          awayRef.current.mouseTextField = true
        }
        break;

      case 35:
      case 36:
        e.stopPropagation();
        break;

      default:
        break;
    }
  }  
  
  React.useEffect(() => {
    //new ResizeObserver((e) => props.cell.getRow().normalizeHeight()).observe(refResize.current);
    // !!! resizeobserver loop limit exceeded at ...
    let resizeObserverTimeout = null;
    new ResizeObserver((e) => {
      clearTimeout(resizeObserverTimeout);
      resizeObserverTimeout = setTimeout(() => {
        props.cell.getRow().normalizeHeight();
      }, 50);
    }).observe(refResize.current);
  }, [props.cell]);
  
  return (
    <Autocomplete
      fullWidth 
      openOnFocus
      multiple={props.multiple}
      disableCloseOnSelect
      value={(value)}
      onClose={onClose}
      onChange={onchange}
      options={props.options}
      getOptionLabel={option => option?.name}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderInput={(params) => {
        //params.InputProps.disableUnderline = true;
        return (
          <TextField              
            {...params} 
            onBlur={onBlurTextField}
            onMouseEnter={(e) => awayRef.current.mouseTextField = false}
            onMouseLeave={(e) => awayRef.current.mouseTextField = true}
            onKeyDown={onKeyDownTextField}
            autoFocus
            margin='dense'
            fullWidth
            ref={refResize}
            size="small"
            variant="outlined"
            sx={{mt:'2px', mb:'1px', my:'1px', '& input': { padding: 0.5}}}
          />
        )
      }}              

      renderOption={(props, option, { selected }) => (
        <MenuItem {...props} key={option.id}>
          <DoneIcon htmlColor={selected ? theme.palette.primary.main : 'transparent'}/>
          <span>&nbsp;</span>
          <ListItemText primary={option.name}/>
        </MenuItem>
      )}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip label={option.name} {...getTagProps({ index })} size="small"/>
        ))
      }
    />
  );
}
